import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight } from "lucide-react";
import { useEnquiry } from "../context/EnquiryContext";
import { ILLO } from "../lib/assets";

export default function LeadPopup() {
  const [open, setOpen] = useState(false);
  const { openEnquiry } = useEnquiry();

  useEffect(() => {
    const seen = sessionStorage.getItem("didit_popup_seen");
    if (!seen) {
      const t = setTimeout(() => setOpen(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("didit_popup_seen", "1");
  };

  const getQuote = () => {
    close();
    openEnquiry("quote", "popup");
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[90] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="lead-popup"
        >
          <div className="absolute inset-0 bg-navy/50 backdrop-blur-sm" onClick={close} />
          <motion.div
            className="relative w-full max-w-md bg-warm border border-navy/10 shadow-2xl"
            initial={{ scale: 0.9, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 10 }}
            transition={{ type: "spring", stiffness: 240, damping: 24 }}
          >
            <button
              data-testid="lead-popup-close"
              onClick={close}
              className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center border border-navy/15 text-navy hover:bg-navy hover:text-warm transition-colors"
              aria-label="Close"
            >
              <X size={16} />
            </button>

            <div className="h-44 bg-[#F3F1EC] overflow-hidden flex items-center justify-center border-b border-navy/10">
              <img src={ILLO.design} alt="DIDIT design" className="h-full w-full object-cover" />
            </div>

            <div className="p-8">
              <p className="text-[11px] tracking-[0.3em] uppercase text-terracotta">DIDIT · Design Install Deliver</p>
              <h2 className="font-display text-2xl md:text-3xl font-light text-navy mt-4 leading-snug">
                Want to know how much your home interiors will cost?
              </h2>
              <p className="text-ink/70 text-sm mt-3 leading-relaxed">
                Get a tailored estimate from our designers — no obligations.
              </p>
              <button
                data-testid="lead-popup-get-quote"
                onClick={getQuote}
                className="group mt-6 w-full flex items-center justify-center gap-2 rounded-full bg-navy text-warm px-8 py-4 text-sm font-medium hover:bg-terracotta transition-colors"
              >
                Get Quote
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
